import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

/**
 * Fondo del carrusel de noticias: la imagen de la noticia actual difuminada a pantalla de
 * la card + scrim oscuro para legibilidad. Superficie OSCURA en ambos modos a propósito
 * (lenguaje de la card de noticia que pidió el usuario); sin imagen cae al gradiente hero.
 */
function CarouselBackdrop({ image = null, alt = '' }) {
  return (
    <Box aria-hidden sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      {image ? (
        <Box
          key={image}
          component="img"
          src={image}
          alt={alt}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(40px) saturate(1.15)',
            transform: 'scale(1.2)',
            animation: `${fadeIn} 400ms cubic-bezier(0.32, 0.72, 0, 1)`
          }}
        />
      ) : (
        <Box sx={{ position: 'absolute', inset: 0, background: (theme) => theme.palette.brand.heroGradient }} />
      )}
      {/* Scrim fijo: superficie oscura en ambos modos (texto blanco encima). */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(10, 12, 14, 0.88) 0%, rgba(10, 12, 14, 0.62) 55%, rgba(10, 12, 14, 0.42) 100%)'
        }}
      />
    </Box>
  );
}

CarouselBackdrop.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string
};

export default CarouselBackdrop;
